<template>
    <div class="weChat-button" @click.capture="openApp">
        <template v-if="$wxConfig?.data?.appId && showButton">
            <wx-open-launch-app
                class="wx-button"
                :id="`launch-btn-${idName}`"
                appid="wx4ab005521f9f1c04"
                :extinfo="$wxConfig.extinfo"
            >
                <script type="text/wxtag-template">
                    <style>
                    .btn {
                    width:100%;
                    height:10000px;
                    display: block;
                    transform: translateY(-50%);
                    z-index: 1000000;
                    }
                    </style>
                    <p class="btn">&emsp;</p>
                </script>
            </wx-open-launch-app>
        </template>
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
import { computed, watch, ref, onMounted } from 'vue';
import Vue from 'vue';
import wx from 'weixin-js-sdk';
import { useStoreCommon } from '@common/store/common';

const emits = defineEmits(['buttonShow']);

const storeCommon = useStoreCommon();

const $wxConfig = computed(() => storeCommon.wxConfig);

const showButton = ref(false);
watch(() => $wxConfig.value, (newVal) => {
    if (newVal.data?.appId) {
        showButton.value = true;
        setWxConfig();
    }
}, { immediate: true, });

const idName = (Math.random() * +new Date().getTime()).toFixed(0);

const setWxConfig = async(): Promise<void> => {
    const { appId, timestamp, nonceStr, signature, } = $wxConfig.value.data;
    await wx.config({ debug: false, appId, timestamp, nonceStr, signature, jsApiList: [], openTagList: ['wx-open-launch-app'], });
    wx.error((res: any) => {
        console.log('wx error', res);
        emits('buttonShow');
    });

    const btn = document.getElementById(`launch-btn-${idName}`);
    // config配置挂载完毕
    btn?.addEventListener('ready', () => {
        console.log('ready-buttonWechat');
    });
    // 点击打开app微信操作
    btn?.addEventListener('launch', () => {
        console.log('success-buttonWechat');
    });
    // 在复制链接里打开会出现launch:fail的情况，走原始逻辑，打开引导
    btn?.addEventListener('error', () => {
        console.log('error-buttonWechat');
        showButton.value = false;
    });
};
const openApp = (event: Event) => {
    // 非微信环境且不在七猫APP内，打开七猫APP
    if (!storeCommon.systemInfo.isWeixin && !storeCommon.systemInfo.inQmApp) {
        Vue.prototype.$openAPP();
        event.stopPropagation();
        event.preventDefault();
    }
};
onMounted(() => {
});
</script>
<style lang="scss" scoped>
.weChat-button {
    position: relative;
    font-size: 20px;
    z-index: 10;
}
.wx-button {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 100;
}
</style>
